export default __webpack_public_path__ + "images/c7befabb4613c322b8708745f3f6a1fe-7_tablet_1067x470.jpg";